"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetWorldInstance = useGetWorldInstance;
var react_1 = require("react");
var util_1 = require("../util");
var api_1 = require("../api");
var sentry_1 = require("../sentry");
var i18n_1 = __importDefault(require("../i18n"));
function useGetWorldInstance(state) {
    (0, react_1.useEffect)(function () {
        if (!state.worldInstanceFetching && state.requestWorldInstanceIds.length) {
            var worldInstanceId = state.requestWorldInstanceIds[0];
            var worldId_1 = worldInstanceId.worldId;
            var locationInfo_1 = worldInstanceId.locationInfo;
            var targetWorldInstance = state.worldInstance(worldId_1, locationInfo_1.instanceFullId);
            var location_1 = "".concat(worldId_1, ":").concat(locationInfo_1.instanceFullId);
            if ((0, util_1.isWorldInstanceNeedFetch)(targetWorldInstance)) {
                state.setWorldInstanceFetching(true);
                (0, api_1.fetchWorldInstance)(worldId_1, locationInfo_1.instanceFullId).then(function (worldInstance) {
                    state.setPlayerModerationsFetchRequest(true);
                    (0, api_1.fetchProfilesByUsers)(worldInstance.users).then(function (userProfiles) {
                        var userProfilesHash = {};
                        for (var _i = 0, userProfiles_1 = userProfiles; _i < userProfiles_1.length; _i++) {
                            var userProfile = userProfiles_1[_i];
                            userProfilesHash[userProfile.id] = userProfile;
                        }
                        state.addWorldInstance({
                            worldId: worldId_1,
                            worldInstance: __assign(__assign({}, worldInstance), { users: worldInstance.users.map(function (user) { return (__assign(__assign({}, user), { status: "", note: "", location: location_1, travelingToLocation: "", locationInfo: locationInfo_1, profile: userProfilesHash[user.id] })); }) }),
                        });
                        state.dispatchRequestWorldInstanceIds({ operation: "shift" });
                        state.setWorldInstanceFetching(false);
                    }, function (error) {
                        (0, sentry_1.captureException)(error);
                        state.incrementErrorCount();
                        alert("".concat(i18n_1.default.instances, "\n").concat(error));
                        state.dispatchRequestWorldInstanceIds({ operation: "shift" });
                        state.setWorldInstanceFetching(false);
                    });
                }, function (error) {
                    (0, sentry_1.captureException)(error);
                    state.incrementErrorCount();
                    alert("".concat(i18n_1.default.instances, "\n").concat(error));
                    state.dispatchRequestWorldInstanceIds({ operation: "shift" });
                    state.setWorldInstanceFetching(false);
                });
            }
        }
    }, [state.worldInstanceFetching, state.requestWorldInstanceIds.length]);
}
